import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ArrowLeft, FileText } from 'lucide-react';
import Footer from '@/components/Footer';

const Terms = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTerms = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/policies/terms`);
        setContent(response.data.content);
      } catch (error) {
        console.error('Failed to load terms:', error);
      } finally {
        setLoading(false);
      }
    };
    
    fetchTerms();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-purple-500 border-t-transparent"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Custom styles to preserve HTML inline styles */}
      <style>{`
        .terms-content * {
          all: revert;
        }
        .terms-content {
          line-height: normal;
        }
        .terms-content p {
          margin: 0 0 6px;
        }
        .terms-content h2 {
          margin: 0 0 4px;
        }
        .terms-content h3 {
          margin: 6px 0 4px;
        }
        .terms-content ul {
          margin: 0 0 6px 1rem;
          padding: 0;
        }
        .terms-content li {
          margin: 2px 0;
        }
        .terms-content section {
          padding: 8px 0;
          border-bottom: 1px solid #eef0f4;
        }
      `}</style>
      
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 text-gray-600 hover:text-purple-600 transition-colors">
              <ArrowLeft className="w-5 h-5" />
              Back to Home
            </Link>
            <Link to="/login" className="text-purple-600 hover:text-purple-700 font-semibold">
              Login
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-8 md:p-12">
          {/* Title */}
          <div className="flex items-center gap-3 mb-8">
            <div className="w-12 h-12 bg-purple-100 rounded-xl flex items-center justify-center">
              <FileText className="w-6 h-6 text-purple-600" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-bold text-gray-900" style={{ fontFamily: 'Space Grotesk' }}>
                Terms & Conditions
              </h1>
              <p className="text-sm text-gray-500 mt-1">Last Updated: 15 November 2022</p>
            </div>
          </div>

          {/* Terms Content */}
          <div className="max-w-none">
            {content ? (
              <div 
                className="terms-content" 
                dangerouslySetInnerHTML={{ __html: content }}
              />
            ) : (
              <div className="whitespace-pre-wrap text-gray-700 leading-relaxed" style={{ fontFamily: 'system-ui' }}>
{`Shootzu
MEMBERSHIP TERMS & CONDITIONS
INCLUDING CREW CONTRACT
(AUSTRALIA) - Last Updated: 15 November 2022

1. OVERVIEW

1.1 The Shootzu mobile phone app or website ("The Platform"), owned and operated by Turbo Productions Pty Ltd, ABN 18 150 556 102 ("Shootzu", "the Zu", "us" or "we") is a Platform for videography and photography professionals, specialising in various industries who capture, or edit video and photo products who are job seekers ("Crew"), which could include creating photo and video inputs for prospective hirers ("Business Users").

1.2 As the context requires "Members", "users" or "you" includes both Business Users and Crew.

1.3 These Terms constitute a legal document that is an agreement between you and Turbo Productions Pty Ltd. By registering as a Member and using the Platform, you agree that these Terms will govern both your Membership and the use of the Platform each time you use the Platform. If you do not wish to be bound by these Terms, or if you are in any way unsure about your ability to comply with these Terms, then you must not become a Member.

[Note: Full terms content would be displayed here from the database]`}
              </div>
            )}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Terms;